import { useContext, useState } from 'react';
import Dialog from '@/components/Dialog';
import { FormattedMessage } from 'react-intl';
import useApi from '@/lib/api/useApi';
import FileChipRemoveButton from '@/components/FileAttachments/FileChip/FileChipRemoveButton';
import RubricsPortfolioContext from '@/lib/contexts/RubricsPortfolioContext';
import useRubricsPortfolioApiEndpoint from '../../../../../useRubricsPortfolioApiEndpoint';
import { type RubricProofLink } from '@/lib/types';

type DeleteProofLinkProps = {
  proofLink: RubricProofLink;
};

const DeleteProofLink = ({ proofLink }: DeleteProofLinkProps) => {
  const api = useApi();
  const rubricsPortfolioApiEndpoints = useRubricsPortfolioApiEndpoint();

  const [, setPortfolio] = useContext(RubricsPortfolioContext);

  const [confirmationDialogOpen, setConfirmationDialogOpen] = useState(false);
  const [deleting, setDeleting] = useState(false);

  const deleteProofLink = async (): Promise<void> => {
    setConfirmationDialogOpen(false);
    setDeleting(true);

    await api.delete(
      `${rubricsPortfolioApiEndpoints}/proof-links/${proofLink.id}`,
    );

    setPortfolio(portfolio => {
      delete portfolio.proofLinks[proofLink.levelId][proofLink.id];
    });

    setDeleting(false);
  };

  return (
    <>
      <FileChipRemoveButton
        onClick={() => setConfirmationDialogOpen(true)}
        disabled={deleting}
      />
      <Dialog
        open={confirmationDialogOpen}
        onClose={() => setConfirmationDialogOpen(false)}
        dangerous
      >
        <Dialog.Title>
          <FormattedMessage id="portfolio.level.attachments.proof.proof_link.delete.dialog.title" />
        </Dialog.Title>
        <Dialog.Content>
          <Dialog.ContentText>
            <FormattedMessage id="portfolio.level.attachments.proof.proof_link.delete.dialog.text" />
          </Dialog.ContentText>
        </Dialog.Content>
        <Dialog.Actions>
          <Dialog.Actions.CancelButton
            onClick={() => setConfirmationDialogOpen(false)}
          />
          <Dialog.Actions.DeleteButton onClick={deleteProofLink} />
        </Dialog.Actions>
      </Dialog>
    </>
  );
};

export default DeleteProofLink;
